import { NotFoundScreen } from '@/modules/errors/components';
import { Redirect, useLocalSearchParams, type Href } from 'expo-router';
import React from 'react';

type MissingRouteParams = {
  missing?: string | string[];
  adhaReturn?: string;
  url?: string;
  code?: string;
  accessCode?: string;
};

function toMissingSegments(missing: string | string[] | undefined): string[] {
  if (Array.isArray(missing)) {
    return missing;
  }
  if (missing) {
    return [missing];
  }
  return [];
}

function appendStringParam(
  query: URLSearchParams,
  key: string,
  value: string | undefined,
): void {
  if (typeof value === 'string' && value) {
    query.set(key, value);
  }
}

function buildUaePassRedirectHref(params: MissingRouteParams): string {
  const query = new URLSearchParams();
  appendStringParam(query, 'adhaReturn', params.adhaReturn);
  appendStringParam(query, 'url', params.url);
  appendStringParam(query, 'code', params.code);
  if (typeof params.accessCode === 'string' && params.accessCode) {
    query.set('code', params.accessCode);
  }
  const qs = query.toString();
  if (qs) {
    return `/uae-pass?${qs}`;
  }
  return '/uae-pass';
}

function isExpoDevClientUaePassReturn(missing: string[]): boolean {
  return missing[0] === '--' && missing.includes('uae-pass');
}

/**
 * Catch-all route for unmatched routes.
 * Expo Dev Client UAE Pass returns can land on `/--/uae-pass`; send those
 * back into the ADHA callback screen.
 */
export default function MissingRoute() {
  const params = useLocalSearchParams<MissingRouteParams>();
  const missing = toMissingSegments(params.missing);

  if (isExpoDevClientUaePassReturn(missing)) {
    return <Redirect href={buildUaePassRedirectHref(params) as Href} />;
  }

  return <NotFoundScreen />;
}
